import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "fadein grid p-0 mt-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-center mb-3 w-full"
}
const _hoisted_3 = {
  key: 1,
  class: "w-full"
}
const _hoisted_4 = { class: "m-0 p-0 flex" }
const _hoisted_5 = { class: "chart col-fixed m-0 p-0 pb-1" }

import Chart from 'primevue/chart';
import Legend from '@/components/Legend';
import { storeToRefs } from 'pinia';
import { useAttendanceStore } from '@/store';
import { onMounted, ref, watch } from 'vue';
import { AttendanceResults } from '@/types';

interface LabelInterface {
  total: string;
  title: string;
  color: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityAttendanceChart',
  setup(__props) {

const AttendanceStore = useAttendanceStore();
const { results } = storeToRefs(AttendanceStore);
const primeChart = ref();

const chartData = {
  datasets: [
    {
      backgroundColor: [] as string[],
      labels: [] as LabelInterface[],
      data: [] as string[],
    },
  ],
};

const colors = {
  ['Present']: '#045C5C',
  ['No Show']: '#94703C',
  ['Absent']: '#94703C',
  ['Late Cancel']: '#474299',
  ['Service Provider Cancelled']: '#7F3666',
  ['No School']: '#26728E',
  ['Customer Cancelled']: '#C3370b',
};

function getAttendanceData(): void {
  chartData.datasets[0].data = [];
  chartData.datasets[0].backgroundColor = [];
  chartData.datasets[0].labels = [];

  results.value
    .sort((a, b) => (a.count < b.count ? 1 : -1))
    .map((result: AttendanceResults) => {
      chartData.datasets[0].data.push(result?.count);
      chartData.datasets[0].backgroundColor.push(colors[result?.name] as string);
      chartData.datasets[0].labels.push({
        total: result.count.toString(),
        title: result.name,
        color: colors[result.name] as string,
      });
    });

  if (!primeChart.value?.chart?.data) {
    return;
  }

  const chart = primeChart.value.chart;
  chart.data = chartData;
  chart.update();
}

onMounted(() => {
  getAttendanceData();
});

watch(results, () => {
  getAttendanceData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(results).every((result) => result.count === 0))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "No data to view."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Chart), {
                ref_key: "primeChart",
                ref: primeChart,
                type: "doughnut",
                data: chartData
              }, null, 512)
            ]),
            _createVNode(_unref(Legend), {
              labels: chartData?.datasets[0].labels,
              class: "legend"
            }, null, 8, ["labels"])
          ])
        ]))
  ]))
}
}

})